import React, { useState } from 'react';
import { NavLink as RouteNavLink } from 'react-router-dom';
import { Nav, NavItem, NavLink } from 'shards-react';
import { connect } from 'react-redux';
import { renderLinks } from '../../../utils/sidebarConfig';
import NavItemIcon from './NavItemIcon';

/**
 * Export a component to render a list with elements in Sidebar menu
 *
 */

const SidebarNavItems = ({ isUserAdmin, services, pathname }) => {
	const settingsMenu = pathname.includes('/settings/'); //Defining a variable for when the settings link should be active.
	const [docsDropdown, setDocsDropdown] = useState(pathname.includes('/documents/')); //Define a variable to show or hide documents submenus.

	const handleDocsDropdown = () => setDocsDropdown(!docsDropdown);

	return (
		<div className='nav-wrapper scrollbar'>
			<Nav className='nav--no-borders flex-column'>
				{renderLinks(docsDropdown, handleDocsDropdown, services, settingsMenu)
					.filter((item) => (item.adminCheck && isUserAdmin) || !item.adminCheck)
					.map((item, index) => (
						<NavItem key={index}>
							<NavLink to={item.path} tag={item.tag ? item.tag : RouteNavLink} active={item.active} onClick={item.clickHandler} className={item.class}>
								{item.iconBefore && <i className={item.iconBefore} />}
								<span>{item.title}</span>
								{item.iconAfter && <i className={item.iconAfter} />}
							</NavLink>
							{docsDropdown &&
								item.children &&
								item.children.map((child, index) => (
									<NavLink key={index} to={`${item.path}/${child.id}/0`} disabled={child.id === 'error'} active={pathname.includes(child.id)} tag={RouteNavLink} className='ml-4 position-relative'>
										<NavItemIcon serviceId={child.id} startStatus={child.activeDocs} iconClass={child.serviceType} />
										<span className={child.class}>{child.name}</span>
									</NavLink>
								))}
						</NavItem>
					))}
			</Nav>
		</div>
	);
};

const mapStateToProps = ({ userData: { services, isUserAdmin } }) => ({
	isUserAdmin,
	services,
});

export default connect(mapStateToProps)(SidebarNavItems); //Export component and connect it with redux.
